import { useEffect } from "react"
import { Route, Routes, useNavigate } from "react-router-dom"
import ProtectedRoute from "./components/ProtectedRoute"
import { protectedRoutes, publicRoutes } from "./routes"
import Navbar from "./components/Navbar"
import { useIdleTimer } from "react-idle-timer"
import { useAuth, useLogout } from "./hooks/useAuth"
import {
  getRefreshToken,
  removeTokensFromLocalStorage,
  removeUserFromLocalStorage,
  setOtpVerification,
} from "./utils"
import routePaths from "./constants/path"
import { refreshTokenExpired } from "./config/axios"
import LogoHeader from "./components/LogoHeader"
import { Toaster } from "sonner"

function App() {
  const navigate = useNavigate()
  const { user } = useAuth()
  const { mutate: logout } = useLogout()

  const handleLogout = () => {
    const refreshToken = getRefreshToken()
    logout(refreshToken.token, {
      onSettled: () => {
        navigate(routePaths.login, {
          replace: true,
        })
      },
    })
  }

  useEffect(() => {
    const refreshToken = getRefreshToken()
    if (refreshToken && refreshTokenExpired()) {
      removeTokensFromLocalStorage()
      removeUserFromLocalStorage()
      setOtpVerification(false)
      navigate(routePaths.login, {
        replace: true,
      })
    }
  }, [navigate])

  useIdleTimer({
    disabled: !user?.userId,
    timeout: 1000 * 60 * 30, // 30 minutes
    onIdle: handleLogout,
    debounce: 1000,
    crossTab: true,
  })

  return (
    <>
      <Routes>
        {protectedRoutes?.map((route) => (
          <Route
            key={route.path}
            element={
              <>
                <Navbar />
                <div className="max-w-9xl mx-auto px-4 mt-6 pt-14">
                  <ProtectedRoute
                    component={route.element}
                    otpVerified={route.otpVerified}
                    whoCanAccess={route.canAccess}
                  />
                </div>
              </>
            }
            path={route.path}
          />
        ))}
        {publicRoutes?.map((route) => (
          <Route
            key={route.path}
            element={
              <>
                <LogoHeader />
                <div key={route.path} className="mx-auto mt-10 pt-14">
                  {route.element}
                </div>
              </>
            }
            path={route.path}
          />
        ))}
      </Routes>
      <Toaster closeButton richColors expand={true} position="top-right" />
    </>
  )
}

export default App
